import { routes } from "router/routes"

/**
 * Generates a trip/experience link based on available identifiers
 * @param {Object} trip - Trip/Experience object
 * @param {number|string} trip.trip_id - Trip ID
 * @param {string} trip.status - Trip status (published, draft, unpublished, deactivated)
 * @returns {string} - The generated link
 */
export const generateTripLink = (trip) => {
    const { trip_id, status } = trip || {}

    if (trip_id) {
        // Same targets as ExperienceCard's Edit; the wizard sets ?type= from the loaded experience
        if (status === "draft") return `#${routes.proNewExperienceV2Path({ id: trip_id })}`
        const route = ["deactivated", "unpublished"].includes(status) ? "deactivated" : "published"
        return `#${routes.proEditExperienceV2Path({ id: trip_id }, { route })}`
    }

    return "#"
}

/**
 * Generates a booking details link based on booking UUID
 * @param {Object} booking - Booking object
 * @param {string} booking.booking_uuid - Booking UUID
 * @returns {string} - The generated link
 */
export const generateBookingLink = (booking) => {
    const { booking_uuid } = booking || {}

    if (booking_uuid) {
        // Use route helper function with booking UUID
        return `#${routes.guideBookingDetailsPath({ id: booking_uuid })}`
    }

    return "#"
}
